import React from "react";
import { cx } from "../utils";

const CcCard = ({
  as: Component = "article",
  tone,
  bone = false,
  className,
  children,
  ...props
}) => (
  <Component
    className={cx(
      "cc-card",
      bone && "cc-card--bone",
      tone && `cc-card--${tone}`,
      className,
    )}
    {...props}
  >
    <div className="cc-card__body">{children}</div>
  </Component>
);

export default CcCard;
